import {CxEvent} from "@spartacus/core";

export class GonvarriNavigateToCheckoutEvent extends CxEvent {
  static override readonly type = 'GonvarriNavigateToCheckoutEvent';
  total_weight?: string;
  total_price?: string;
  user_id?: string;
  user_email?: string;
  total_tax?: string;
  total_gross?: string;
}

export class GonvarriQuoteNavigateToCheckoutEvent extends CxEvent {
  static override readonly type = 'GonvarriQuoteNavigateToCheckoutEvent';
  user_id?: string;
  user_email?: string;
  quotation_order_number?: string;
}